// All marketing content for Perth Tiling WA

export const CONTACT = {
  phone: "0420 524 388",
  phoneRaw: "0420524388",
  email: "admin@perthtilingwa.com.au",
  area: "Perth, Western Australia",
};

export const NAV = [
  { label: "Work", href: "#specialities" },
  { label: "Process", href: "#process" },
  { label: "Gallery", href: "#gallery" },
  { label: "Studio", href: "#studio" },
  { label: "Enquire", href: "#enquire" },
];

export const HERO = {
  overline: "Perth's Complete Tiling Specialists",
  lines: ["Precision Tiling", "for Exceptional", "Spaces"],
  intro:
    "Perth's trusted wall and floor tilers — bathrooms, kitchens, outdoor areas and commercial fit-outs in ceramic, porcelain, mosaic, large-format and natural stone. Obligation-free written quotes, meticulous workmanship, across the Perth metro.",
  image:
    "https://images.unsplash.com/photo-1756079664354-34944e001f6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtYXJibGUlMjBiYXRocm9vbXxlbnwwfHx8fDE3ODY4MzYxMjV8MA&ixlib=rb-4.1.0&q=85",
};

export const TRUST_POINTS = [
  "Obligation-free written quotes",
  "Rectified & large-format specialists",
  "Every tile type — ceramic to natural stone",
  "Fully insured · Perth metro",
];

export const SPECIALTY = {
  overline: "What We Do",
  title: "Every Aspect of Tiling",
  body:
    "From everyday ceramics to book-matched marble, we handle the complete job — old tile removal, substrate preparation, AS 3740 waterproofing and precision installation, including rectified large-format tiles and full bathroom renovations. One team, one uncompromising standard, no shortcuts.",
  points: [
    "All tile types — ceramic, porcelain, stone & mosaic",
    "Rectified large-format porcelain up to 3200 × 1600mm",
    "Natural marble, travertine and granite",
    "Tile removal & surface preparation",
    "Full bathroom renovations, end to end",
    "Repairs, renovations and new builds",
  ],
  image:
    "https://images.unsplash.com/photo-1719324923413-ba0a066465c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxsYXJnZSUyMGZvcm1hdCUyMHBvcmNlbGFpbiUyMHNsYWJ8ZW58MHx8fHwxNzg2ODM2MTI1fDA&ixlib=rb-4.1.0&q=85",
};

export const CATEGORIES = [
  {
    id: "bathroom",
    index: "01",
    title: "Bathroom & Wet Areas",
    tag: "Ensuite · Main Bath · Powder",
    body:
      "Sanctuary-grade wet areas built to last. From full-height marble showers to classic subway tiling and book-matched vanity walls, we deliver flawless falls, sealed junctions and a seamless finish that turns everyday rituals into something considered.",
    image:
      "https://images.unsplash.com/photo-1564540583246-934409427776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtYXJibGUlMjBiYXRocm9vbSUyMGludGVyaW9yJTIwZGV0YWlsfGVufDB8fHx8MTc4NjgzNjE5Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "kitchen",
    index: "02",
    title: "Kitchen & Splashbacks",
    tag: "Splashbacks · Island Cladding",
    body:
      "The heart of the home deserves a statement surface. From mosaic and subway splashbacks to full-slab porcelain and waterfall island cladding, we install with continuous veining and crisp, clean lines from bench to wall.",
    image:
      "https://images.unsplash.com/photo-1658280911730-467b4764c09c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBraXRjaGVuJTIwc3RvbmUlMjBzcGxhc2hiYWNrfGVufDB8fHx8MTc4NjgzNjEyNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "outdoor",
    index: "03",
    title: "Outdoor & Pool",
    tag: "Alfresco · Pool Surrounds · Coping",
    body:
      "Weather-ready surfaces engineered for the WA climate. Slip-rated porcelain, precise coping and level alfresco transitions that blur the line between inside and out — beautiful, and built for barefoot summers.",
    image:
      "https://images.unsplash.com/photo-1557459310-ea39155bd081?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBzd2ltbWluZyUyMHBvb2wlMjB0aWxpbmd8ZW58MHx8fHwxNzg2ODM2MTI1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "commercial",
    index: "04",
    title: "Commercial",
    tag: "Lobbies · Retail · Hospitality",
    body:
      "High-traffic spaces that need to look immaculate for decades. We partner with builders and designers on lobbies, showrooms and hospitality fit-outs, delivering to program without compromising on finish.",
    image:
      "https://images.unsplash.com/photo-1758448721205-8465cebc26af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwYnVpbGRpbmclMjBsdXh1cnklMjBsb2JieSUyMHN0b25lJTIwZmxvb3J8ZW58MHx8fHwxNzg2ODM2MTk2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "feature-walls",
    index: "05",
    title: "Feature Walls",
    tag: "Fireplaces · Statement Cladding",
    body:
      "A single wall can define an entire room. We install dramatic stone, porcelain and mosaic feature walls — fireplace surrounds, media walls and entry statements — with hairline joints and perfect plumb.",
    image:
      "https://images.unsplash.com/photo-1533044309907-0fa3413da946?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxmZWF0dXJlJTIwd2FsbCUyMHN0b25lJTIwY2xhZGRpbmclMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODY4MzYxOTZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "tile-removal",
    index: "06",
    title: "Tile Removal",
    tag: "Strip-Out · Surface Preparation",
    body:
      "The unglamorous work that decides the final finish. We remove old tiles, adhesive and failed screed quickly and cleanly, then prepare and level the substrate properly — so your new tiling starts on a foundation that won't let it down.",
    image:
      "https://images.unsplash.com/photo-1551893478-d726eaf0442c?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "rectified-tiling",
    index: "07",
    title: "Rectified Tiling",
    tag: "Large-Format · Hairline Joints",
    body:
      "Precision-cut rectified tiles laid with hairline 1.5mm joints for that seamless, architectural look. We specialise in large-format porcelain up to 3200 × 1600mm — dry-laid, levelled with clip systems and finished with near-invisible grout lines.",
    image:
      "https://images.unsplash.com/photo-1744025098626-66c0b9cb1ba8?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "bathroom-renovations",
    index: "08",
    title: "Bathroom Renovations",
    tag: "Complete Transformations · End to End",
    body:
      "More than tiling — complete bathroom transformations managed end to end. Strip-out, waterproofing, tiling, fixtures and finishing, coordinated with trusted trades and delivered with one point of accountability: ours.",
    image:
      "https://images.unsplash.com/photo-1663811397133-2d1f5addd9d5?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const PROCESS = [
  {
    n: "01",
    title: "Consultation",
    body:
      "We visit the site, understand the vision, and advise on tile selection, setout and detailing before a single tile is cut.",
  },
  {
    n: "02",
    title: "Preparation",
    body:
      "Substrates are checked, levelled and waterproofed to Australian Standards. Precision here is what makes the finish last.",
  },
  {
    n: "03",
    title: "Installation",
    body:
      "Every tile — from mosaic to large-format slab — is set with the right system for minimal lippage, clean joints and true lines.",
  },
  {
    n: "04",
    title: "Handover",
    body:
      "We grout, seal and detail-clean, then walk the space with you. Nothing leaves our hands until it meets our standard.",
  },
];

export const MARQUEE = [
  "All Tile Types",
  "Ceramic & Porcelain",
  "Natural Stone",
  "Mosaics",
  "Large-Format",
  "Waterproofing",
  "Book-Matched Veining",
  "Precision Setout",
];

export const GALLERY = [
  { src: "/work/work-2.jpg", h: "tall", alt: "Travertine bathroom with burgundy herringbone feature wall — Perth Tiling WA project" },
  { src: "https://images.unsplash.com/photo-1658280911730-467b4764c09c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBraXRjaGVuJTIwc3RvbmUlMjBzcGxhc2hiYWNrfGVufDB8fHx8MTc4NjgzNjEyNXww&ixlib=rb-4.1.0&q=85", h: "short", alt: "Stone kitchen splashback" },
  { src: "/work/work-4.jpg", h: "tall", alt: "Marble-look bathroom wall with mitred corner and timber vanity — Perth Tiling WA project" },
  { src: "https://images.unsplash.com/photo-1557459310-ea39155bd081?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBzd2ltbWluZyUyMHBvb2wlMjB0aWxpbmd8ZW58MHx8fHwxNzg2ODM2MTI1fDA&ixlib=rb-4.1.0&q=85", h: "tall", alt: "Pool surround tiling" },
  { src: "https://images.unsplash.com/photo-1738585608732-49294c24ece0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxmZWF0dXJlJTIwd2FsbCUyMHN0b25lJTIwY2xhZGRpbmclMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODY4MzYxOTZ8MA&ixlib=rb-4.1.0&q=85", h: "short", alt: "Stone feature wall" },
  { src: "https://images.unsplash.com/photo-1762883608901-8b2d4ddd517e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwYnVpbGRpbmclMjBsdXh1cnklMjBsb2JieSUyMHN0b25lJTIwZmxvb3J8ZW58MHx8fHwxNzg2ODM2MTk2fDA&ixlib=rb-4.1.0&q=85", h: "short", alt: "Commercial stone floor" },
  { src: "/work/work-1.jpg", h: "tall", alt: "Subway tile shower with patterned encaustic-look floor — Perth Tiling WA project" },
  { src: "https://images.unsplash.com/photo-1523413651479-597eb2da0ad6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHx3aGl0ZSUyMHN1YndheSUyMHRpbGUlMjBraXRjaGVuJTIwc3BsYXNoYmFja3xlbnwwfHx8fDE3ODY4NDAyNDB8MA&ixlib=rb-4.1.0&q=85", h: "short", alt: "White subway tile splashback" },
  { src: "/work/work-3.jpg", h: "tall", alt: "Marble-look shower walls with black floor tiles — Perth Tiling WA project" },
];

export const TESTIMONIALS = [
  {
    quote:
      "The book-matched marble in our ensuite is genuinely breathtaking. The joints are almost invisible — you can see the craftsmanship in every detail.",
    name: "Rebecca M.",
    role: "Dalkeith Residence",
  },
  {
    quote:
      "We engaged Perth Tiling WA for a full commercial fit-out. On program, immaculate finish, and a team that actually cares about the outcome.",
    name: "James T.",
    role: "Commercial Builder",
  },
  {
    quote:
      "From the mosaic splashback to the large-format floors, every surface was finished beautifully. Exactly the seamless look we were after.",
    name: "Sophie & Daniel",
    role: "City Beach Home",
  },
];

export const SERVICE_OPTIONS = CATEGORIES.map((c) => c.title).concat(["General Enquiry"]);

export const BUDGET_OPTIONS = ["Under $2k", "$2k – $10k", "$10k – $20k", "$20k+", "Not sure yet"];

export const PARTNER = {
  overline: "In Collaboration With",
  name: "Modify",
  body:
    "Perth Tiling WA works in close collaboration with Modify and Exclusive Tiling & Stone. These partnerships are how we're able to take on bigger commercial fit-outs and full-scale renovations right across the Perth metro area — combined resources and shared standards, with one uncompromising commitment to craftsmanship.",
  points: [
    "Greater capacity for large-scale projects",
    "Full-scale renovations across Perth metro",
    "Shared European-standard quality benchmarks",
  ],
};
